import React, { Component } from 'react';
import { GoogleLogin } from '@react-oauth/google';

export default class SignIn extends Component {
    constructor(props) {
        super(props);

        this.state = {}
    }

    loginSuccess = (gResponse) => {
        fetch('api/login?token=' + gResponse.credential , {
            method: 'GET'
        })
        .then(response => {
            if (response.ok) {
                response.json().then(data => {
                    sessionStorage.setItem('token', gResponse.credential);
                    if(data.newUser === false) {
                        this.props.history.push('/dashboard/' + data.googleId);
                    } else {
                        this.props.history.push('/profile/' + data.googleId);
                    }
                })
            } else {
                alert('There was an error in the sign in process.  Please try again at a later time.');
            }            
        })
    }

    loginFailure = () => {
        alert('Your login with Google was unsuccessful.  Please try again.');
    }

    render() {
        return(            
            <div
                className="rounded px-3 px-sm-4 py-3 py-sm-5"
                style={{ backgroundColor: "#e9ecef" }}
            >
                <h2>Apply for a Board or Commission</h2>
                <hr />
                <p className='lead'>
                    St. Louis County requires that its applicants have an active Google account.  To get started, click the "Sign in with Google" button below.  If this is your first time applying for a board, we will ask you to complete a profile before applying for a board or commission.
                </p>
                <p className='lead'>
                    Once your profile is completed, you will have access to your dashboard.  The dashboard will allow you to apply to boards and commissions, see previous applications, see application status, and edit your profile.
                </p>
                <GoogleLogin 
                    onSuccess={this.loginSuccess}
                    onError={this.loginFailure}
                />
            </div>            
        )
    }
}